import settingSlice from 'reducers/setting/reducer';

const { actions, reducer } = settingSlice;

export const settingActions = actions;

export default reducer;
